import { createStore } from 'vuex'
import {log} from "@/composables/useLog";
import { getToken as getStoredToken, clearTokenStorage } from "@/composables/useTokenStorage";

export default createStore({
  state: {
    loggedIn: false,
    user:null,
    token:null,
    selectedUser:null,
    selecteClient:null,
    fcmToken: null,
    acType: null,
    activePaymentToken: null,
    activePaymentPanMasked: null,
    currentTransaction: null,
    lastTransaction: null,
    updateStationsSignal: false,
    generalSettings: {},
    displaySettings: {},
    currentView:null,
  },
  mutations: {
    setLoggedIn: (state, payload) => {
      log("in store scriem setLoggedIn :"+ payload)
      state.loggedIn = payload
    },
    setCurrentView: (state,payload) => {
      log("in store scriem setCurrentPage :"+ payload)
      state.currentView = payload
    },
    setToken: (state,payload) => {
      log("in store scriem setToken :"+ payload)
      state.token = payload.token
    },
    setUser: (state, payload) => {
      log("in store scriem setUser :"+ payload)
      state.user=payload.user
    },
    setSelectedUser: (state, payload) => {
      log("in store scriem setSelectedUser :"+ payload)
      state.selectedUser=payload
    },
    setSelectedClient: (state, payload) => {
      log("in store scriem setSelectedClient :"+ payload)
      state.selectedClient=payload.selectedClient
    },
     setGeneralSettings: (state, payload) => {
      log("in store scriem setGeneralSettings")
      state.generalSettings=payload
    },
    setDisplaySettings: (state, payload) => {
      state.displaySettings = payload
    },
    setLoggedOut: (state) => {
      state.user=null
      state.fcmToken=null
      state.acType=null
      state.loggedIn=false
      state.token=null
      state.selectedUser=null
      state.selecteClient=null
      state.activePaymentToken=null
      state.activePaymentPanMasked=null
      state.currentTransaction=null
      state.lastTransaction=null
      state.updateStationsSignal=false
      state.generalSettings={}
      state.displaySettings={}
      state.currentView=null
      // Clear all token storage (both localStorage and sessionStorage)
      clearTokenStorage()
    },
    // Impersonation session - stores in sessionStorage (tab-specific)
    setImpersonationSession: (state, payload) => {
      log("in store scriem setImpersonationSession")
      sessionStorage.setItem('token', payload.token)
      sessionStorage.setItem('user', JSON.stringify(payload.user))
      sessionStorage.setItem('impersonated', 'true')
      state.token = payload.token
      state.user = payload.user
      state.loggedIn = true
    },

  },
  actions: {
    loginSuccess({ commit }) {
      commit("setLoggedIn", true);
    },
    logout({ commit }) {
      commit("setLoggedIn", false);
    },
  },
  getters: {
    isLoggedIn: (state) => state.loggedIn,
    getLoggedIn: state => state.loggedIn,
    getDistributorId: state => state.distributorId,
    // Token getter: uses helper that checks sessionStorage first, then localStorage
    getToken: state => {
      return state.token || getStoredToken()
    },
    // User getter: check sessionStorage first (impersonation), then state
    getUser: state => {
      const sessionUser = sessionStorage.getItem('user')
      if (sessionUser) {
        try {
          return JSON.parse(sessionUser)
        } catch (e) {
          return state.user
        }
      }
      return state.user
    },
    // Check if current session is impersonated
    isImpersonated: () => {
      return sessionStorage.getItem('impersonated') === 'true'
    },
    // Get impersonated by info
    getImpersonatedBy: state => {
      const sessionUser = sessionStorage.getItem('user')
      if (sessionUser) {
        try {
          const user = JSON.parse(sessionUser)
          return user.impersonated_by || null
        } catch (e) {
          return null
        }
      }
      return state.user?.impersonated_by || null
    },
    getCurrentView: state => state.currentView,
    getGeneralSettings: state => state.generalSettings,
    getDisplaySettings: state => state.displaySettings,
    getSelectedUser: state => state.selectedUser,
    getSelecteClient: state => state.generalSettings,
    getRoles: state => {
      const sessionUser = sessionStorage.getItem('user')
      if (sessionUser) {
        try {
          const user = JSON.parse(sessionUser)
          return user.roles || []
        } catch (e) {
          return state.user?.roles || []
        }
      }
      return state.user?.roles || []
    },
  },
})
